import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetInactivePlayerTableData } from '@/modules/manage-player/type'
import InactivePlayerTable from '../InactivePlayerTable'
import { MonthPicker } from '@/common/components/MonthPicker'
import MonthRangeButtons from '@/common/components/MonthRangeButtons'

type SortOrder = 'asc' | 'desc' | undefined
interface InactivePlayerListingProps {
	data: GetInactivePlayerTableData[]
	total: number
	date: Date
	isLoading?: boolean
	onSort: (columnId: string, order: SortOrder) => void
}

export default function InactivePlayerListing({
	data,
	date,
	total,
	isLoading,
	onSort,
}: InactivePlayerListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
				<Heading
					title={`รายงานสมาชิกเลิกเล่น`}
					description="รายงานสมาชิกเลิกเล่น"
				/>
				<div className="flex flex-col gap-2 sm:items-end">
					<MonthPicker />
					<MonthRangeButtons />
				</div>
			</div>
			<Separator />
			<InactivePlayerTable
				data={data}
				date={date}
				total={total}
				isLoading={isLoading}
				onSort={onSort}
			/>
		</div>
	)
}
